export const signUpSteps = {
    stepPhoneInput: "gatherPhoneNumber",
    stepSMSCodeInput: "gatherAndValidateSMSCode",
    stepSignUp: "gatherSignUpFields"
}
